import { GetAddress } from '@/services/api/map'

export const state = {
  center: { lat: -2.958881, lng: 109.5543666 },
  zoom: 5.56,
  address: [],
  infoWindow: {
    position: { lat: 0, lng: 0 },
    open: false,
    address: '',
    woNumber: '',
    technician: null,
    type: 'user',
  },
  type: 'user',
  vehicleIds: [],
  pickedColumns: [],

  modalUserHistory: false,
  selectedTechnician: null,

  draggableMarkerPosition: null,  // { lat, lng }
  woLayerActive: true,   // default aktif
  homeLayerActive: false, // default nonaktif
  // ✅ tambahkan
  mapCenter: null,
  customerLocation: null,
  disableAutoCenter: false,
  areaFilter: 'all', // 'all' | 'west' | 'east'
}

export const actions = {
  setCENTER({ commit }, payload) {
    commit('CENTERING', payload)
  },
  setZOOM({ commit }, payload) {
    commit('ZOOM', payload)
  },
  closeInfo({ commit }, payload) {
    commit('CLOSE_INFO', payload)
  },
  modalUserHistory({ commit }, payload) {
    commit('MODAL_HISTORY', payload)
  },
  async requestAddress({ commit }, payload) {
    await GetAddress(payload.lat, payload.lng).then((res) => {
      commit('SET_ADDRESS', res.data.display_name)
    })
  },
}

export const mutations = {
  CENTERING(state, payload) {
    if (payload.gmp) {
      state.center.lat = parseFloat(payload.gmp.latitude)
      state.center.lng = parseFloat(payload.gmp.longitude)
      state.zoom = payload.zoom
      state.infoWindow.open = payload.open
      state.infoWindow.position.lat = parseFloat(payload.gmp.latitude)
      state.infoWindow.position.lng = parseFloat(payload.gmp.longitude)
      if (payload.open) {
        state.infoWindow.detail = payload.gmp
      }
      state.infoWindow.type = payload.type
    } else {
      state.infoWindow = {
        position: { lat: 0, lng: 0 },
        open: false,
        address: '',
        detail: {
          vehicle: {
            driver1: null,
          },
          alert: {
            alertCode: 0,
            descriptionIdn: null,
          },
        },
        vehicle: null,
      }

      state.infoWindow.type = payload.type

      state.center.lat = -2.958881
      state.center.lng = 109.5543666
      state.zoom = 5.56
    }
  },
  ZOOM(state, payload) {
    state.zoom = payload.zoom
    state.center.lat = payload.lat
    state.center.lng = payload.lng
  },
  CLOSE_INFO(state, payload) {
    state.infoWindow.open = payload
  },
  MODAL_HISTORY(state, payload) {
    state.modalUserHistory = payload
  },
  SET_ADDRESS(state, payload) {
    state.infoWindow.address = payload
  },

  TYPE_OF_MAP(state, payload) {
    state.type = payload
  },
  TYPE_OF_MAP_INFOWINDOW(state, payload) {
    state.infoWindow = {
      position: { lat: 0, lng: 0 },
      open: false,
      address: '',
      detail: {
        vehicle: {
          driver1: null,
        },
        alert: {
          alertCode: 0,
          descriptionIdn: null,
        },
      },
      vehicle: null,
      type: payload,
    }
  },
  SET_VEHICLEIDS(state, payload) {
    state.vehicleIds = payload
  },
  SET_PICKED_COLUMNS(state, payload) {
    state.pickedColumns = payload
  },
  SET_SELECTED_TECHNICIAN(state, technician) {
    state.selectedTechnician = technician;
  },
  SET_CENTER(state, { lat, lng, zoom }) {
    state.center.lat = lat;
    state.center.lng = lng;
    if (zoom !== undefined) {
      state.zoom = zoom;
    }
  },
  SET_DRAGGABLE_MARKER_POSITION(state, pos) {
    state.draggableMarkerPosition = pos
  },
  SET_ZOOM(state, zoom) {
    state.zoom = zoom;
  },
  SET_WO_LAYER(state, value) {
    state.woLayerActive = value;
  },
  SET_HOME_LAYER(state, value) {
    state.homeLayerActive = value;
  },
  SET_HOME_LAYER_ACTIVE(state, val) {
    state.homeLayerActive = val;
  },
  SET_CUSTOMER_LOCATION(state, location) {
    state.customerLocation = location;
  },
  SET_DISABLE_AUTO_CENTER(state, value) {
    state.disableAutoCenter = value;
  },
  SET_AREA_FILTER(state, filter) {
    state.areaFilter = filter;
  },
}
